import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import startApp from '@purecarslabs/signal-core/baseline/app'
import isStorybook from '@purecarslabs/signal-utils/env/isStorybook.js'
import { inJest } from '@app-src/utils'
import { APP_NAME, APP_ROUTES, PROJECT_NAME } from './routes'

if (!inJest() && !isStorybook()) {
  startApp({
    public: true,
    appName: APP_NAME,
    appRoutes: APP_ROUTES,
    projectName: PROJECT_NAME
  })
}
